module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-account-status-filter"
  }, [_c('AccountStatus', {
    attrs: {
      "accountStatus": _vm.status,
      "statuses": _vm.statuses
    },
    on: {
      "input": _vm.toggle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2515957a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/AccontStatusFilter.vue
// module id = 2213
// module chunks = 1